import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'retailer_pos-logged_in_footer_banner-click';
/**
 * Logged in user clicked the POS banner on page footer
 */ export function trackRetailerPosLoggedInFooterBannerClick(Segment) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            Segment: Segment
        }
    });
}
